import MainIcon from "../Icons/Menus/main.svg";
// import IntroIcon from "../Icons/Menus/intro.svg";
import LinksIcon from "../Icons/Menus/links.svg";
import NewsIcon from "../Icons/Menus/news.svg";
import VisitorIcon from "../Icons/Menus/visitor.svg";
import ServicesIcon from "../Icons/Menus/services.svg";
import ApplicationIcon from "../Icons/Menus/application.svg";
import Step1 from "../Icons/StepIcons/step1.svg";
import Step2 from "../Icons/StepIcons/step2.svg";
import Step3 from "../Icons/StepIcons/step3.svg";
import Step4 from "../Icons/StepIcons/step4.svg";
import Step5 from "../Icons/StepIcons/step5.svg";
import Step6 from "../Icons/StepIcons/step6.svg";
import AccountabilityIcon from "../Icons/Services/AccountabilityIcon.svg";
import BestIcon from "../Icons/Services/BestIcon.svg";
import OptionalServicesIcon from "../Icons/Services/OptionalServicesIcon.svg";
import PositiveExperienceIcon from "../Icons/Services/PositiveExperienceIcon.svg";

import BellIcon  from "../Icons/BellIcon.svg";
import RightUpArrowIcon  from "../Icons/rightUpArrow.svg";
import Course_trainingIcon  from "../Icons/Announcement/course_training.svg";
import Dental_appointmentIcon  from "../Icons/Announcement/dental_appointment.svg";
import Announcement1 from "../Icons/Announcement/Announcement1.png";
import Announcement2 from "../Icons/Announcement/Announcement2.png";
import Announcement3 from "../Icons/Announcement/Announcement3.png";
import Announcement4 from "../Icons/Announcement/Announcement4.png";
import Announcement5 from "../Icons/Announcement/Announcement5.png";
import Announcement6 from "../Icons/Announcement/Announcement6.png";
import Announcement7 from "../Icons/Announcement/Announcement7.png";
import Announcement8 from "../Icons/Announcement/Announcement8.png";
import Announcement9 from "../Icons/Announcement/Announcement9.png";
import Announcement10 from "../Icons/Announcement/Announcement10.png";

import ChartedCarService from "../Icons/Announcement/Charted Car Service.png";
import GuardianService from "../Icons/Announcement/Guardian Service.png";
import LandingPackage from "../Icons/Announcement/Landing Package.png";
import PickupService from "../Icons/Announcement/Pickup Service.png";
import WeekendActivities from "../Icons/Announcement/Weekend Activities.png";

import English_trialclaIcon  from "../Icons/Announcement/english_trial_cls.svg";
import Extracurricular_activitiesIcon  from "../Icons/Announcement/extracurricular_activities.svg";
import Rent_paymentIcon  from "../Icons/Announcement/rent_payment.svg";
import Repair_applicationIcon  from "../Icons/Announcement/repair_application.svg";
import Weekend_activitiesIcon  from "../Icons/Announcement/weekend_activities.svg";
import University_tutionIcon  from "../Icons/Announcement/university_tution.svg";
import Subject_tutionIcon  from "../Icons/Announcement/subject_tution.svg";
import contactIcon  from "../Icons/Account/ContactUs.svg";
import HomeIcon  from "../Icons/Account/Home.svg";
import IntroIcon  from "../Icons/Account/Intro.svg";
import CelebrationIcon from '@mui/icons-material/Celebration';
import LoginIcon from '@mui/icons-material/Login';

export const menus = [
  {
    id: 1,
    nav_bar_name: "Home",
    isdrobdown: 0,
    uri_link: "/",
    icon: HomeIcon,
  },
  {
    id: 2,
    nav_bar_name: "About Us",
    isdrobdown: 0,
    uri_link: "/intro",
    icon: IntroIcon,
  },
  {
    id: 3,
    nav_bar_name: "Application",
    isdrobdown: 0,
    uri_link: "/application",
    icon: ApplicationIcon,
  },
  {
    id: 4,
    nav_bar_name: "Services",
    isdrobdown: 1,
    uri_link: "/services",
    icon: ServicesIcon,
    submenu: [
      { id: 41, name: "Web Development", link: "/services/web" },
      { id: 42, name: "App Development", link: "/services/app" },
      { id: 43, name: "SEO Optimization", link: "/services/seo" },
    ],
  },
  {
    id: 5,
    nav_bar_name: "News",
    isdrobdown: 0,
    uri_link: "/news",
    icon: NewsIcon,
  },
  {
    id: 6,
    nav_bar_name: "Visitor",
    isdrobdown: 0,
    uri_link: "/visitor",
    icon: VisitorIcon,
  },
  {
    id: 7,
    nav_bar_name: "Links",
    isdrobdown: 0,
    uri_link: "/links",
    icon: LinksIcon,
  },
  {
    id: 8,
    nav_bar_name: "Contact us",
    isdrobdown: 0,
    uri_link: "/contact-us",
    icon: contactIcon,
  },
];

export const Steps = [
  {
    id: 1,
    name: "Step 1",
    Description: "<p>Choose Accommodation Type</p><br>",
    icon: Step1,
  },
  {
    id: 2,
    name: "Step 2",
    Description: "<p>Fill Out The Information Form</p><br>",
    icon: Step2,
  },
  {
    id: 3,
    name: "Step 3",
    Description: "<p>Pay Deposit</p><br><br>",
    icon: Step3,
  },
  {
    id: 4,
    name: "Step 4",
    Description: "<p>Pending Confirmation</p><br><br>",
    icon: Step4,
  },
  {
    id: 5,
    name: "Step 5",
    Description: "<p>Sign The Contract & Pay The Rent</p><br>",
    icon: Step5,
  },
  {
    id: 6,
    name: "Step 6",
    Description: "<p>Fly to Singapore & Start A New Life</p><br>",
    icon: Step6,
  },
];

export const ServicesSteps = [
  {
    id: 1,
    name: "Accountability",
    icon: AccountabilityIcon,
  },
  {
    id: 2,
    name: "Best in class",
    icon: BestIcon,
  },
  {
    id: 3,
    name: "Optional Services",
    icon: OptionalServicesIcon,
  },
  {
    id: 4,
    name: "Positive experience",
    icon: PositiveExperienceIcon,
  },
];

export const AnnounceMentList = [
  {
    id : 1,
    name : 'Landing<br> Package',
    icon : LandingPackage,
    arrow : RightUpArrowIcon,
    navigate : '/services/67ed05c6f078ad0b0d13aeb8'
  },
  {
    id : 2,
    name : 'Subject<br> Tuition',
    icon : Announcement7,
    arrow : RightUpArrowIcon,
    navigate : '/services/67ed0715f078ad0b0d13aeca'
  },
  {
    id : 3,
    name : 'Pick-up<br> Service',
    icon : PickupService,
    arrow : RightUpArrowIcon,
    navigate : '/services/67ed0668f078ad0b0d13aebc'
  },
  {
    id : 4,
    name : 'Academy<br> Pathway Counseling',
    icon : Announcement6,
    arrow : RightUpArrowIcon,
    navigate : '/services/67ed06cdf078ad0b0d13aec6'
  },
  {
    id : 5,
    name : 'Chartered<br> Car Service',
    icon : ChartedCarService,
    arrow : RightUpArrowIcon,
    navigate : '/services/67ed069df078ad0b0d13aec2'
  },
  {
    id : 6,
    name : 'Weekend<br> Activities',
    icon : WeekendActivities,
    arrow : RightUpArrowIcon,
    navigate : '/services/67ed0746f078ad0b0d13aed0'
  },
  {
    id : 7,
    name : 'Guardian<br> Service',
    icon : GuardianService,
    arrow : RightUpArrowIcon,
    navigate : '/services/67e51f134c55fa7d61bf7771'
  },
  {
    id : 8,
    name : 'Festival<br> Activities',
    icon : Announcement3,
    arrow : RightUpArrowIcon,
    navigate : '/services/67ed0778f078ad0b0d13aed6'
  },
  {
    id : 9,
    name : 'English<br> Trial Class',
    icon : Announcement5,
    arrow : RightUpArrowIcon,
    navigate : '/services/67ed04b6f078ad0b0d13ae8b'
  },
  {
    id : 10,
    name : 'International<br> Competition',
    icon : Announcement8,
    arrow : RightUpArrowIcon,
    navigate : '/services/67ed07abf078ad0b0d13aedc'
  }
]